import axios from 'axios';
import { API_BASE_URL, AUTH_ENDPOINTS, USER_ENDPOINTS } from '../utils/endPoints';
import { createApiClient } from '../utils/axiosConfig';
import {
  SigninCredentials,
  SigninResponse,
  UserProfile,
  UpdateUserProfilePayload,
  ApiErrorResponse,
} from '../types/auth';

export type { ApiErrorResponse, SigninCredentials, SigninResponse, UserProfile, UpdateUserProfilePayload };

export const signInUser = async (credentials: SigninCredentials): Promise<SigninResponse> => {
  try {
    const encodedCredentials = btoa(`${credentials.username}:${credentials.password}`);
    const response = await axios.get<SigninResponse>(
      `${API_BASE_URL}${AUTH_ENDPOINTS.SIGNIN}`,
      {
        headers: {
          Authorization: `Basic ${encodedCredentials}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      const apiError = error.response.data as ApiErrorResponse;
      throw new Error(apiError.message || 'Authentication failed');
    } else {
      console.error('Signin service error:', error);
      throw new Error('An unexpected error occurred during signin.');
    }
  }
};

const apiClient = createApiClient();

export const getUserProfile = async (): Promise<UserProfile> => {
  try {
    const token = localStorage.getItem('authToken');
    const response = await apiClient.get<UserProfile>(USER_ENDPOINTS.GET_USER_DETAILS, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      const apiError = error.response.data as ApiErrorResponse;
      throw new Error(apiError.message || 'Failed to fetch profile');
    } else {
      throw new Error('An unexpected error occurred while fetching your profile.');
    }
  }
};

export const updateUserProfile = async (profileData: UpdateUserProfilePayload): Promise<{ user: UserProfile, message: string }> => {
  try {
    const token = localStorage.getItem('authToken');
    let dataToSend: any = profileData;
    let headers: any = { Authorization: `Bearer ${token}` };
    if (profileData && (profileData as any).profileImage instanceof File) {
      const formData = new FormData();
      Object.entries(profileData).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          formData.append(key, value as any);
        }
      });
      dataToSend = formData;
      headers['Content-Type'] = 'multipart/form-data';
    }
    const response = await apiClient.put<{ user: UserProfile, message: string }>(USER_ENDPOINTS.UPDATE_USER, dataToSend, { headers });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      const apiError = error.response.data as ApiErrorResponse;
      throw new Error(apiError.message || 'Failed to update profile');
    } else {
      console.error('Update user profile service error:', error);
      throw new Error('An unexpected error occurred while updating your profile.');
    }
  }
};

export const signUpUser = async (userData: any): Promise<void> => {}; 